import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, AlertController } from 'ionic-angular';

import { Project, Master } from '@providers/index';

@Component({
  selector: 'page-form-project',
  templateUrl: 'page.html'
})
export class FormProjectPage {

  project:any = {
    contract_number:''
  };
  loading:any;
  listCompany:any=[];
  listBranch:any=[];
  listSBU:any=[];
  listDepartmen:any=[];
  listRate:any=[];
  listStage:any=[];
  readyLoadMaster=0;

  projek:any={};
  global:any={};
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public projectApi: Project,
    public masterApi: Master
  ) {
    if(this.navParams.get('project')!=undefined){
      this.project = this.navParams.get('project');
    }
    this.getMaster();
    this.getLanguage();
  }

  getLanguage(){
    this.masterApi.language().subscribe((resp:any) => {
      this.global = resp.global;
      this.projek = resp.project;
    });
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
 
  save(){    
    this.showLoading();

    this.projectApi.post(this.project).subscribe((resp:any) => {
      
      this.loading.dismiss();
      if(resp.success){
        this.presentToast(resp.msg);
        this.navCtrl.pop();
      }else{
        let alert = this.alertCtrl.create({
          title: 'Gagal Menyimpan',
          subTitle: resp.msg,
          buttons: ['Dismiss']
        });
        alert.present();
      }
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  getStage(){
    let params = {};
    this.masterApi.stage(params).subscribe((resp:any) => {
      this.listStage = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster==6){
        this.loading.dismiss();
      }
    });
  }

  getCompany(){
    let params = {};
    this.masterApi.company(params).subscribe((resp:any) => {
      this.listCompany = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster==6){
        this.loading.dismiss();
      }
    });
  }

  getSBU(){
    let params = {};
    this.masterApi.sbu(params).subscribe((resp:any) => {
      this.listSBU = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster==6){
        this.loading.dismiss();
      }
    });
  }

  getBranch(){
    console.log('b');
    let params = {};
    this.masterApi.branch(params).subscribe((resp:any) => {
      this.listBranch = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster==6){
        this.loading.dismiss();
      }
    });
  }

  getDepartmen(){
    let params = {};
    this.masterApi.department(params).subscribe((resp:any) => {
      this.listDepartmen = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster==6){
        this.loading.dismiss();
      }
    });
  }

  getRate(){
    let params = {};
    this.masterApi.rate(params).subscribe((resp:any) => {
      this.listRate = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster==6){
        this.loading.dismiss();
      }
    });
  }

  getMaster(){
    this.showLoading();
    this.getCompany();
    this.getBranch();
    this.getSBU();
    this.getDepartmen();
    this.getStage();
    this.getRate();
  }
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/form_project/page.ts